import React, { useMemo } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";

import { useTheme } from "../../contexts/ThemeContext";
import { hexToRgba } from "../../utils/themes";

/** Single-ring gauge: accent fill for avg match (0–100), muted track carries the remainder. No tooltips. */
const MatchRateDonut = ({ value = 0, valueClassName = "" }) => {
  const { theme } = useTheme();
  const isLight = theme.mode === "light";
  const accent = theme.accent;
  const stroke = theme.border;

  const clamped = Math.max(0, Math.min(100, Number(value) || 0));
  const remainder = Math.max(0, 100 - clamped);

  const trackFill = useMemo(() => {
    const base = isLight ? theme.borderBright : "#1C2030";
    return hexToRgba(base.startsWith("#") ? base : theme.border, isLight ? 0.35 : 0.5);
  }, [isLight, theme.border, theme.borderBright]);

  const pieData = useMemo(
    () => [
      { key: "score", value: clamped },
      { key: "track", value: remainder },
    ],
    [clamped, remainder],
  );

  return (
    <div className="h-52 w-full relative">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="key"
            startAngle={90}
            endAngle={450}
            innerRadius={55}
            outerRadius={76}
            stroke={stroke}
            isAnimationActive={false}
          >
            <Cell key="filled" fill={accent} stroke={stroke} />
            <Cell key="trail" fill={trackFill} stroke={stroke} />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className={`text-3xl font-mono font-bold ${valueClassName || "text-theme-on-background"}`}>
          {clamped}%
        </div>
      </div>
    </div>
  );
};

export default MatchRateDonut;
